'use strict';var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj};Object.defineProperty(exports,'__esModule',{value:!0});exports.default=function(object){return'object'===('undefined'==typeof HTMLElement?'undefined':_typeof(HTMLElement))?object instanceof HTMLElement:1===object.nodeType};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/StringFunctions/checkElement.js
// module id = 770
// module chunks = 0